const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
const STORAGE_KEY = 'vaultlynk_utm'

export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search)
  const utm: Record<string, string> = {}
  let hasUtm = false
  for (const key of UTM_PARAMS) {
    const value = params.get(key)
    if (value) {
      utm[key] = value
      hasUtm = true
    }
  }
  if (hasUtm) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm))
  }
}

export function getUtmParams(): Record<string, string> {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
  } catch {
    return {}
  }
}
